import React from "react";

type ChevronDownIconProps = {
  stroke?: string;
  strokeWidth?: string;
};

export const ChevronDownIcon = (props: ChevronDownIconProps = {}) => {
  const { stroke = "var(--blue-600)", strokeWidth = 2 } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M6 9L12 15L18 9"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
